import { render, staticRenderFns } from "./VipHeadConfirmPopup.vue?vue&type=template&id=0c3e77ca&scoped=true&"
import script from "./VipHeadConfirmPopup.vue?vue&type=script&lang=js&"
export * from "./VipHeadConfirmPopup.vue?vue&type=script&lang=js&"
import style0 from "./VipHeadConfirmPopup.vue?vue&type=style&index=0&id=0c3e77ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3e77ca",
  null
  
)

export default component.exports